import { backgroundOrange, darkOrange, red, warmTint, white } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { breakpoints, contentWidth, radii } from '@/theme/tokens'
import styled from 'styled-components'

export const OverviewWrapper = styled.div`
	background-color: ${backgroundOrange};
	flex: 1;
	overflow-y: auto;
	width: 100%;
`

export const OverviewContainer = styled.div`
	/* The shared content column — the navbar and breadcrumbs align to this same
	   width and 36px gutter (see theme/layout contentShell). */
	max-width: ${contentWidth};
	margin: 0 auto;
	padding: 40px 36px 64px;

	/* The single-column stack uses 18px gutters per the handoff (m-pad). */
	@media (max-width: ${breakpoints.bentoCollapse}px) {
		padding: 24px 18px 48px;
	}

	@media (max-width: ${breakpoints.phone}px) {
		padding: 16px 18px 40px;
	}
`

export const TripSettingsButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	background: ${white};
	color: ${darkOrange};
	border: 1px solid ${warmTint};
	border-radius: ${radii.inner};
	padding: 8px 14px;
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 14px;
	cursor: pointer;
	transition:
		background 0.2s ease-out,
		transform 0.12s ease-out;

	&:hover {
		background: ${warmTint};
	}

	&:active {
		transform: scale(0.97);
	}

	&:focus-visible {
		outline: 2px solid ${darkOrange};
		outline-offset: 2px;
	}
`

export const ErrorState = styled.div`
	padding: 4rem 2rem;
	text-align: center;
	color: ${red};
`
